import psychologyConsultationClient from '@/axiosClients/psychologyConsultationClient';


const isFirstSession = (formData) => psychologyConsultationClient.get(`/is-first-evaluation/${formData.room_name}`);

export default {
    isFirstSession
}
